<template>
  <div>
  <modal name="modal-summary"
    height="auto"
    width="512px"
    @before-open="beforeOpen"
    :clickToClose="false"
    class="modal-page"
    :adaptive="true">
    <i @click="close" v-if="!iconClose" class="close-icon"></i>
    <a @click="close" v-if="iconClose" class="ui basic button close">Close</a>

    <div class="ui grid container modal-summary">
      <div class="headertxt">
        <h4 v-if="details">Summary Details</h4>
      </div>
      <div v-if="details" class="details">
        <h4>You are about to submit the following details.
          Do you wish to proceed?</h4>

        <div class="items">
          <label class="title">Loan ID Number</label>
          <p>{{ loanid }}</p>

          <label class="title">Mobile Number</label>
          <p>+63 {{ mobile }}</p>

          <label class="title">Payment Option</label>
          <p>BPI</p>

          <label class="title">Amount</label>
          <p>{{ amount }}</p>
        </div>

        <p class="sub-p">The bank charges an additional service fee
          which will be added to your payment</p>

        <a @click="submitForm" class="ui button orange">
          PROCEED
        </a>

        <a @click="close" class="cancel">
          Cancel
        </a>
      </div>
      <div v-if="loader" class="loader">
        <h4>Loading Please wait</h4>
        <div class="ui active centered inline massive loader"></div>
      </div>

      <div v-if="error" class="loader">
        <h4>{{ errortxt }}</h4>
        <a @click="close" class="cancel">
          Cancel
        </a>
      </div>
    </div>
  </modal>
</div>
</template>
<script>
const axios = require('axios');
const { apiURL, customer, accountsurl, authUrl } = settings
import settings from '../config/settings.json';

export default {
  name:'modal-summary',
  data() {
    return {
      loanid: '',
      mobile: '',
      bank: '',
      amount: '',
      details: true,
      loader: false,
      channelCode:'',
      customerId: '',
      id: '',
      status: '',
      customer_id: '',
      channel_code: '',
      authorizer_url: '',
      meta: null,
      error: false,
      errortxt: '',
      iconClose: false
    }
  },
  methods: {
    close() {
      location.reload()
    },

    async submitForm()  {

      if(this.amount != null){
        let amount  = this.amount
        amount = amount.replace(/,/g, ""); // remove commas
        amount = parseFloat(amount)
        this.amount = amount
      }

      this.loader = true
      this.details = false

      const apiPath = `${customer}`

      const params = {
        referenceId: this.loanid,
        mobileNumber: "+63"+ this.mobile,
        amount: this.amount
      }

      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }

      await axios.post(apiPath, params, { headers })
      .then( response => {

        if (response.data.paymentServiceResp.errorCode == 0) {
          this.customerId = response.data.customerResp.id
          this.getCustomer()
        } else if (response.data.paymentServiceResp.errorCode == 1) {
          this.loader = false
          this.error = true
          this.errortxt = "Loan ID doesn’t exist."
        } else if (response.data.paymentServiceResp.errorCode == 6001) {
          this.loader = false
          this.error = true
          this.errortxt = "Loan ID doesn’t exist."
        } else if (response.data.paymentServiceResp.errorCode == -999) {
          this.loader = false
          this.error = true
          this.errortxt = "Amount to pay must not be higher than the total loan amount"
        } else {
          this.loader = false
          this.error = true
          this.errortxt = response.data.paymentServiceResp.msg
        }
      })
      .catch( err => {
        console.log(err);
      })
    },

    async getCustomer() {
      var apiPath = `${customer}` + this.customerId

      const params = {
        customerId: this.customerId,
        channelCode: this.channelCode
      }
      const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      await axios.get(apiPath, params, { headers })
      .then( response => {
        this.id = response.data.id
        this.getaccounts()
      })
      .catch( err => {
        console.log(err);
      })
    },

    async getaccounts() {
      var apiPath = `${authUrl}`
      const params = {
        customerId: this.id,
        channelCode: this.channelCode
      }
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
      await axios.post(apiPath, params, { headers })
      .then( response => {
        // console.log(response);
        this.id = response.data.id
        this.status = response.data.status
        this.customer_id = response.data.customer_id
        this.channel_code = response.data.channel_code
        this.authorizer_url = response.data.authorizer_url
        this.meta = null

        window.location.href = this.authorizer_url
      })
      .catch( err => {
        console.log(err);
      })
    },

    beforeOpen(event) {
      this.loanid = event.params.loanid
      this.mobile = event.params.mobile
      this.bank = event.params.bank
      this.amount = event.params.amount
      this.channelCode = event.params.channelCode
      this.checkwindow()
    },

    checkwindow() {
      if ($(window).width() >= 800) {
        this.iconClose = true
      } else if ($(window).width() <= 799) {
        !this.iconClose
      }
    }
  },
  mounted() {
    this.checkwindow()
  }
}
</script>
